import type { WatchingResponse } from '~/models/Housing';
export default function useWatchOffer() {
  const { showToast } = useToast();
  const { t } = useI18n();

  async function startWatchingOffer(targetUserId: number) : Promise<WatchingResponse> {
    const { offerAPI } = useBackendRequests();
    try {
      const response = await offerAPI.startWatching(targetUserId);
      showToast('success', t('liked'), t('ad-added-to-watch-list'));
      return response as WatchingResponse;
    } catch (error) {
      console.error('Error in startWatchingOffer:', error);
      showToast('error', t('error'), t('ad-not-added-to-watch-list'));
      throw new Error('Error in startWatchingOffer');
    }
  }

  async function stopWatchingOffer(targetUserId: number): Promise<WatchingResponse> {
    const { offerAPI } = useBackendRequests();
    try {
      const response = await offerAPI.stopWatching(targetUserId);
      showToast('success', t('unliked'), t('ad-removed-from-watch-list'));
      return response as WatchingResponse;
    } catch (error) {
      console.error('Error in stopWatchingOffer:', error);
      showToast('error', t('error'), t('ad-not-removed-from-watch-list'));
     throw new Error('Error in stopWatchingOffer');
    }
  }

  return {
    startWatchingOffer,
    stopWatchingOffer,
  };
}
